"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pollOption = exports.addNewOptionStyles = exports.pollEditorHeader = exports.resetInput = void 0;

var _emotion = require("emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _consts = require("../consts");

/* eslint-disable indent */
var resetInput =
/*#__PURE__*/
(0, _emotion.css)("background:none;::placeholder{color:", _themeConfig.default.color.dark.cobalt, ";}");
exports.resetInput = resetInput;
var pollEditorHeader =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:column;align-items:flex-start;flex-grow:1;overflow:auto;.poll-question-input{font-family:'Playfair Display' !important;padding:0;font-size:32px;margin-bottom:32px;::placeholder{font-family:PlayfairDisplay;font-size:32px;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;}}");
exports.pollEditorHeader = pollEditorHeader;
var addNewOptionStyles =
/*#__PURE__*/
(0, _emotion.css)("display:flex;margin-top:12px;.plus-icon{margin-right:10px;}");
exports.addNewOptionStyles = addNewOptionStyles;

var pollOption = function pollOption(status, imageUrl) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("border-bottom:1px solid ", _themeConfig.default.color.dark.mars, ";", imageUrl &&
    /*#__PURE__*/
    (0, _emotion.css)(status !== _consts.PollStatus.COMPLETE ?
    /*#__PURE__*/
    (0, _emotion.css)("padding:16px 0;") :
    /*#__PURE__*/
    (0, _emotion.css)("padding:10px 0;")))
  );
};

exports.pollOption = pollOption;